const testOnChooseFileClick = () => {
  console.log('called');
};

export const RsvReaderTest = {
  testOnChooseFileClick,
};
